/* eslint-disable max-len */
/* eslint-disable no-case-declarations */
"use strict";

const {
    ProductQuery,
    TranslationsQuery,
    ProductsQuery,
    CategoryTranslationsQuery
} = require("./helpers/productGraphQLQueries");
const config = require("./helpers/configuration");
const { fromJsonString, getProp, isNullOrEmpty } = require("@nuskin/ns-common-lib");
const { default: axios } = require("axios");
let moment = require("moment")

let envConfig = {};
let activeSalesEvents = ["unitTestsNeedAnEvent"];

const RETAIL = 'Regular Price',
    WHOLESALE = 'Wholesale Price',
    PV = 'PV',
    SB = 'SB',
    CV = 'CV',
    GRP = 'GRP',
    RETAILSUB = 'Sub Retail Price',
    WHOLESALESUB = 'Sub Wholesale Price',
    PVSUB = 'Sub PV',
    SBSUB = 'Sub SB',
    CVSUB = 'Sub CV',
    GRPSUB = 'Sub GRP',
    SALES = 'AfterDiscount',
    ORIGINAL = 'Original'

const activeSubscriberPromotionName = "10% off for active subscriber"
const bundlePromotionName = "Price Offer for Bundle"

const processProps = (props) => {
    if (!props) {
        return "empty";
    } else if (props.fromId) {
        if (!props.env || !["dev", "test", "prod"].includes(props.env)) {
            return "missingEnv";
        } else {
            return "id";
        }
    } else if (props.fromSlug) {
        if (!props.env || !["dev", "test", "prod"].includes(props.env)) {
            return "missingEnv";
        } else {
            return "slug";
        }
    } else if (props.data) {
        if (!props.env || !["dev", "test", "prod"].includes(props.env)) {
            return "missingEnv";
        } else {
            return "data";
        }
    }
};

const isNullOrFieldsEmpty = (variable) => {
    if (isNullOrEmpty(variable)) {
        return true;
    }
    if (typeof variable === "object") {
        let isEmpty = true;
        for (const key in variable) {
            if (Object.hasOwn(variable, key)) {
                if (!isNullOrFieldsEmpty(variable[key])) {
                    isEmpty = false;
                }
            }
        }
        return isEmpty;
    }
    return false;
};

const getProductById = async (id, market, language, useContentSource, quantity, okta) => {
    const payload = { variables: { market, language, id, useContentSource, quantity: quantity || 1, okta } };
    payload.operationName = "ProductById";
    payload.query = `query ProductById($id: String!, $market: String, $language: String, $quantity: Int, $okta: String, $useContentSource: String) {
            productById(id: $id, market: $market, language: $language, quantity: $quantity, okta: $okta, useContentSource: $useContentSource) {
              ${ProductQuery}}}`;
    try {
        const idRes = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((idRes || {}).data || {}).data || {}).productById || (idRes || {}).error;
    } catch (ex) /* istanbul ignore next */ {
        console.error(ex);
    }
};

const getProductsById = async (ids, market, language, useContentSource, quantity, okta, env) => {
    env = env || "prod";
    market = market || "US";
    language = language || "en";
    envConfig = config.getConfig(env);
    const payload = { variables: { ids, market, language, useContentSource, quantity, okta } };
    payload.operationName = "ProductsById";
    payload.query = `query ProductsById($ids: [String!]!, $market: String, $language: String, $useContentSource: String, $quantity: Int, $okta: String) {
        productsById(ids: $ids, market: $market, language: $language, useContentSource: $useContentSource, quantity: $quantity, okta: $okta) {
          validCount
          totalCount
          skip
          ${ProductsQuery}
        }
      }`;
    try {
        const data = await axios.post(`${envConfig.graphqlUrl}`, payload);
        /* istanbul ignore next */
        return (((data || {}).data || {}).data || {}).productsById || (data || {}).errors;
    } catch (ex) /* istanbul ignore next */ {
        console.error(ex);
    }
};

const getProductBySlug = async (slug, market, language, useContentSource, quantity, okta, env) => {
    env = env || "prod";
    market = market || "US";
    language = language || "en";
    envConfig = config.getConfig(env);
    const payload = { variables: { market, language, slug, useContentSource, quantity, okta } };
    payload.operationName = "ProductBySlug";
    payload.query = `query ProductBySlug($slug: String!, $market: String, $language: String, $useContentSource: String, $quantity: Int, $okta: String) {
              productBySlug(slug: $slug, market: $market, language: $language, useContentSource: $useContentSource, quantity: $quantity, okta: $okta) {
                ${ProductQuery}}}`;
    try {
        const idRes = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((idRes || {}).data || {}).data || {}).productBySlug || (idRes || {}).error;
    } catch (ex) /* istanbul ignore next */ {
        console.error(ex);
    }
};

const getPublishedProducts = async (market, language, env, useContentSource) => {
    envConfig = config.getConfig(env);
    const payload = { variables: { market, language, limit: 700, useContentSource } };
    payload.operationName = "PublishedProducts";
    payload.query = `query PublishedProducts($market: String, $language: String, $limit: Int, $useContentSource: String) {
              publishedProducts(market: $market, language: $language, limit: $limit, useContentSource: $useContentSource) {
                totalCount
                validCount
                productIds
              }}`;
    try {
        const idRes = await axios.post(`${envConfig.graphqlUrl}`, payload);
        /* istanbul ignore next */
        return (((idRes || {}).data || {}).data || {}).publishedProducts || (idRes || {}).error;
    } catch (ex)  /* istanbul ignore next */ {
        console.error(ex);
    }
};

const getActiveSalesEvents = async (market) => {
    /* istanbul ignore next */
    envConfig = envConfig || config.getConfig('test');
    const activeEvents = [{ eventName: 'unitTestsNeedAnEvent' }]
    try {
        /* istanbul ignore next */
        let res = axios.get(envConfig.activeEventUrl, { headers: { client_id: envConfig.clientId } });
        res = await res;
        for (const event of (res.data || {}).salesEventResponse || []) {
            /* istanbul ignore next */
            if (event.startTimestamp < Date.now() && event.endTimestamp > Date.now() && event.eventEnabled) {
                if (event.markets.includes(market)) {
                    activeEvents.push({ ...event })
                }
            }
        }
    } catch (ex)  /* istanbul ignore next */ {
        console.log(ex);
    }
    
    activeSalesEvents = activeEvents
    return activeSalesEvents;
};

const setActiveSalesEvents = (events) => {
    activeSalesEvents = events || [];
};

const getPDPStrings = async (market, language, env) => {
    env = env || "prod";
    market = market || "US";
    language = language || "en";
    envConfig = config.getConfig(env);
    const payload = { variables: { market, language } };
    payload.operationName = "PdpStrings";
    payload.query = `query PdpStrings($market: String, $language: String) {
        pdpStrings(market: $market, language: $language) {
              ${TranslationsQuery}}}`;
    try {
        const res = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((res || {}).data || {}).data || {}).pdpStrings || (res || {}).error;
    } catch (ex)  /* istanbul ignore next */ {
        console.error(ex);
    }
};

const getCPStrings = async (market, language, env) => {
    env = env || "prod";
    market = market || "US";
    language = language || "en";
    envConfig = config.getConfig(env);
    const payload = { variables: { market, language } };
    payload.operationName = "CpStrings";
    payload.query = `query CpStrings($market: String, $language: String) {
        cpStrings(market: $market, language: $language) {
              ${CategoryTranslationsQuery}}}`;
    try {
        const res = await axios.post(`${envConfig.graphqlUrl}`, payload);
        return (((res || {}).data || {}).data || {}).cpStrings || (res || {}).error;
    } catch (ex)  /* istanbul ignore next */ {
        console.error(ex);
    }
};

/*
    This is the "constructor" for a nuskin product object. 
    You send it an object that will be used to determine what to do  when it initializes
    Possible options:
        {} - Create an empty nsProduct object with no data
        {data: Object} - Create an object using the data previously retrived from the product graphql
        {fromId: String, market: String, language: String, env: String} - Create an object using data retrieved using the ID, market, language, environment sent
        {fromSlug: String, market: String, language: String, env: String} - Create an object using data retrieved using the slug, market, language, environment sent

    Example usage:
        const product = await nsProduct({fromSlug: 'tegreen', market: 'US', language: 'en', env: 'dev'});
        const fromSku = await nsProduct({fromId: '01003440', market: 'US', language: 'en', env: 'dev'});
        const fromUid = await nsProduct({fromId: 'blta50746fc33f83470', market: 'US', language: 'en', env: 'dev'});
        const prodWithOkta = await nsProduct({fromSlug: 'tegreen', market: 'US', language: 'en', env: 'dev', okta: 'oktaToken'});
*/
const getProduct = async (props) => {
    let data = {};
    let productSource = {};
    // Validate props passed in
    const constructorType = processProps(props);
    if (constructorType === "missingEnv") {
        data.error = "Missing env in props, please include the environment and re-initialize";
    } else if (["id", "slug", "data"].includes(constructorType)) {
        // initialize configs and libs
        envConfig = config.getConfig(props.env);
    }
    // Initialize NsProduct based on constructor used
    switch (constructorType) {
        case "id":
            data =
                (await getProductById(
                    props.fromId,
                    props.market || "US",
                    props.language || "en",
                    props.useContentSource,
                    1,
                    props.okta || null
                )) || {};
            productSource = data.productDataSource || {};
            productSource.market = productSource.market || props.market || "US";
            productSource.language = productSource.language || props.language || "en";
            data.productDataSource = productSource;
            for (const variant of data.variants || [])   /* istanbul ignore next */ {
                if (variant.sku === props.fromId || variant.id === props.fromId || variant.globalId === props.fromId) {
                    variant.matchingVariant = true;
                }
            }
            break;
        case "slug":
            data =
                (await getProductBySlug(
                    props.fromSlug,
                    props.market || "US",
                    props.language || "en",
                    props.useContentSource,
                    1,
                    props.okta || null
                )) || {};
            productSource = data.productDataSource || {};
            productSource.market = productSource.market || props.market || "US";
            productSource.language = productSource.language || props.language || "en";
            data.productDataSource = productSource;
            break;
        case "data":
            productSource = {
                ...props.data.productDataSource,
                market: (props.data.productDataSource || {}).market || props.market || "US",
                language: (props.data.productDataSource || {}).language || props.language || "en"
            };
            props.data.productDataSource = productSource;
            data = props.data;
            break;
    }

    /* istanbul ignore next */
    const discountFacets = (facet, facetName, isActiveSubscriber, promotions) => {
        if (typeof (facet[facetName]) !== 'undefined' && typeof (facet[`${facetName}${SALES}`]) !== 'undefined') {
            const extraPromotions = promotions.filter(p => ![bundlePromotionName, activeSubscriberPromotionName].includes(p.message))
            if (!extraPromotions || !Array.isArray(extraPromotions) || extraPromotions.length === 0) {
                let bundlePromo = promotions.filter(p => p.message === bundlePromotionName)
                bundlePromo = bundlePromo.length > 0 ? bundlePromo[0] : null
                if (bundlePromo) {
                    facet[`${facetName}`] = facet[`${facetName}${SALES}`]
                }
                if (!isActiveSubscriber) {
                    facet[`${facetName}${SALES}`] = null
                }
            }
            if (isActiveSubscriber) {
                let activeSubPromo = promotions.filter(p => p.message === activeSubscriberPromotionName)
                activeSubPromo = activeSubPromo.length > 0 ? activeSubPromo[0] : null
                if (activeSubPromo) {
                    facet[`${facetName}${SALES}`] += facet[`${facetName}${SALES}`] / 9
                }
                if (!extraPromotions || !Array.isArray(extraPromotions) || extraPromotions.length === 0) {
                    facet[`${facetName}${SALES}`] = null
                }
            }
            
        }
        return facet
    }

    const getEqPricing = async (variant, bundle, selectedSkus, quantity, okta, productInBundleId) => {
        if (isNullOrEmpty(variant) && isNullOrEmpty(bundle)) {
            return {};
        }
        quantity = quantity || 1;
        const eqData = data.productDataSource;
        let eqHeaders = {
            "Content-Type": "application/json"
        };
        const oktaToken = okta || null;
        if (oktaToken)  /* istanbul ignore next */ {
            eqHeaders.Authorization = oktaToken;
        }
        let eqUrl = `${eqData.apiBaseUrl}/orchestrationservices/storefront/catalogs/products/${productInBundleId || data.id
        }/promotions?locale=${eqData.language}_${eqData.market.toUpperCase()}&storeId=${eqData.storeId}&includeInventoryStatus=true`;
        if (eqData.apiBaseUrl && eqData.apiBaseUrl.indexOf('apis') > -1) {
            eqUrl = `${eqData.apiBaseUrl}/catalogs/products/${productInBundleId || data.id
            }/promotions?locale=${eqData.language}_${eqData.market.toUpperCase()}&storeId=${eqData.storeId}&includeInventoryStatus=true`
        }
        const body = {
            categoryId: ["all_products"],
            quantity: quantity.toString(),
            productId: productInBundleId || data.id,
            isSubscriptionIncludedInPromotion: false,
            isFromBrowse: true
            // isSubscriptionPromotion: true -- Removed (possibly temporarily) due to pricing discrepancies when it's set --
        }
        let currencyCode;
        if (!isNullOrFieldsEmpty(variant)) {
            body.skus = [{ skuId: variant.sku, productId: productInBundleId || data.id, type: 'DEFAULT' }]
            currencyCode = variant.price && variant.price.currencyCode;
        } else if (!isNullOrFieldsEmpty(bundle)) {
            currencyCode = bundle.price && bundle.price.currencyCode;
            selectedSkus = selectedSkus || []
            const skus = []
            const variantsGettingPriced = []
            for (const bundleItem of data.bundle.kitProducts) {
                const variants = bundleItem.product.variants || [];
                let variant = variants[0];
                if (variants.length > 0 && selectedSkus.some((r) => variants.map((s) => s.sku).includes(r))) {
                    variant = (variants.filter((v) => selectedSkus.includes(v.sku)) || [])[0] || variant;
                    variantsGettingPriced.push(
                        getEqPricing(variant, null, null, bundleItem.quantity, okta, (bundleItem.product || {}).id)
                    );
                } else if (!bundleItem.isMandatory) {
                    variant = null;
                }
                if (variant) {
                    skus.push({
                        skuId: variant.sku,
                        productId: bundleItem.product.id,
                        quantity: bundleItem.quantity,
                        type: "kit"
                    });
                }
            }
            body.skus = skus;
            for (const pricing of variantsGettingPriced) {
                await pricing;
            }
        }
        try {
            let res;
            if (oktaToken) {
                res = axios.post(eqUrl, { ...body }, { headers: { ...eqHeaders } });
            } else {
                res = axios.post(eqUrl, { ...body }, { withCredentials : false }, { headers: { ...eqHeaders } });
            }
            const awaitedRes = await res;
            const isSubscribeAndSave = ((awaitedRes || {}).data || {}).isSubscribeSaveEnabled || false
            const totalValue = ((awaitedRes || {}).data || {}).totalValue || {};
            const priceFacets = totalValue.priceFacets || {};
            const promotion = ((awaitedRes || {}).data || {}).promotion || [];
            const activeSubscriberPromotion = promotion.find(p => p.message === activeSubscriberPromotionName)
            const retailFacet = discountFacets(priceFacets[RETAIL] || {}, RETAIL, !!activeSubscriberPromotion, promotion)
            const wholesaleFacet = discountFacets(priceFacets[WHOLESALE] || {}, WHOLESALE, !!activeSubscriberPromotion, promotion)
            const cvFacet = discountFacets(priceFacets[CV] || {}, CV, !!activeSubscriberPromotion, promotion)
            const pvFacet = discountFacets(priceFacets[PV] || {}, PV, !!activeSubscriberPromotion, promotion)
            const sbFacet = discountFacets(priceFacets[SB] || {}, SB, !!activeSubscriberPromotion, promotion)
            const grpFacet = discountFacets(priceFacets[GRP] || {}, GRP, !!activeSubscriberPromotion, promotion)
            const subRetailFacet = discountFacets(priceFacets[RETAILSUB] || {}, RETAILSUB, !!activeSubscriberPromotion, promotion)
            const subWholesaleFacet = discountFacets(priceFacets[WHOLESALESUB] || {}, WHOLESALESUB, !!activeSubscriberPromotion, promotion)
            const subCvFacet = discountFacets(priceFacets[CVSUB] || {}, CVSUB, !!activeSubscriberPromotion, promotion)
            const subPvFacet = discountFacets(priceFacets[PVSUB] || {}, PVSUB, !!activeSubscriberPromotion, promotion)
            const subSbFacet = discountFacets(priceFacets[SBSUB] || {}, SBSUB, !!activeSubscriberPromotion, promotion)
            const subGrpFacet = discountFacets(priceFacets[GRPSUB] || {}, GRPSUB, !!activeSubscriberPromotion, promotion)
            const priceObject = { currencyCode }
            priceObject.retail = retailFacet[RETAIL]
            priceObject.retailSales = retailFacet[`${RETAIL}${SALES}`]
            priceObject.retailSubscription = priceObject.retailSales || priceObject.retail
            if (!isNullOrEmpty(subRetailFacet)) {
                priceObject.retailSubscription = subRetailFacet[`${RETAILSUB}${SALES}`] ? subRetailFacet[`${RETAILSUB}${SALES}`] : subRetailFacet[RETAILSUB] || null
            } 
            priceObject.retailOriginal = retailFacet[`${RETAIL}${ORIGINAL}`]
            priceObject.wholesale = wholesaleFacet[WHOLESALE]
            priceObject.wholesaleSales = wholesaleFacet[`${WHOLESALE}${SALES}`]
            priceObject.wholesaleSubscription = priceObject.wholesaleSales || priceObject.wholesale
            if (!isNullOrEmpty(subWholesaleFacet)) {
                priceObject.wholesaleSubscription = subWholesaleFacet[`${WHOLESALESUB}${SALES}`] ? subWholesaleFacet[`${WHOLESALESUB}${SALES}`] : subWholesaleFacet[WHOLESALESUB] || null
            }
            priceObject.wholesaleOriginal = wholesaleFacet[`${WHOLESALE}${ORIGINAL}`]

            const pointsObject = {
                wholesale: { cv: cvFacet[`${CV}${SALES}`] || cvFacet[CV], pv: pvFacet[`${PV}${SALES}`] || pvFacet[PV], sb: sbFacet[`${SB}${SALES}`] || sbFacet[SB], grp: grpFacet[`${GRP}${SALES}`] || grpFacet[GRP] },
                original: { cv: cvFacet[`${CV}${ORIGINAL}`], pv: pvFacet[`${PV}${ORIGINAL}`], sb: sbFacet[`${SB}${ORIGINAL}`], grp: grpFacet[`${GRP}${ORIGINAL}`] }
            };
            pointsObject.subscription = {...pointsObject.wholesale}
            /* istanbul ignore next */
            if (!isNullOrEmpty(subCvFacet) || !isNullOrEmpty(subPvFacet) || !isNullOrEmpty(subSbFacet) || !isNullOrEmpty(subGrpFacet) || !isNullOrEmpty(subRetailFacet) || !isNullOrEmpty(subWholesaleFacet)) {
                pointsObject.subscription.cv = subCvFacet ? Number(subCvFacet[`${CVSUB}${SALES}`] || subCvFacet[CVSUB]).toFixed(2) : 0
                pointsObject.subscription.pv = subPvFacet ? Number(subPvFacet[`${PVSUB}${SALES}`] || subPvFacet[PVSUB]).toFixed(2) : 0
                pointsObject.subscription.sb = subSbFacet ? Number(subSbFacet[`${SBSUB}${SALES}`] || subSbFacet[SBSUB]).toFixed(2) : 0
                pointsObject.subscription.grp = subGrpFacet ? Number(subGrpFacet[`${GRPSUB}${SALES}`] || subGrpFacet[GRPSUB]).toFixed(2) : null
                if (!pointsObject.subscription.grp) {
                    pointsObject.subscription.grp = Number((priceObject.retailSubscription || 0) - (priceObject.wholesaleSubscription || 0)).toFixed(2)
                }
            }
            
            //Update this with subscribeandsave
            if (isSubscribeAndSave) /* istanbul ignore next */ {
                priceObject.retailSubscription = priceObject.retail ? Number(Number(priceObject.retail * .9).toFixed(2)) : null
                priceObject.wholesaleSubscription = priceObject.wholesale ? Number(Number(priceObject.wholesale * .9).toFixed(2)) : null
                pointsObject.subscription.cv = pointsObject.wholesale.cv ? Number(Number(pointsObject.wholesale.cv * .9).toFixed(2)) : 0
                pointsObject.subscription.pv = pointsObject.wholesale.pv ? Number(Number(pointsObject.wholesale.pv * .9).toFixed(2)) : 0
                pointsObject.subscription.sb = pointsObject.wholesale.sb ? Number(Number(pointsObject.wholesale.sb * .9).toFixed(2)) : 0
                pointsObject.subscription.grp = pointsObject.wholesale.grp ? Number(Number(pointsObject.wholesale.grp * .9).toFixed(2)) : 0
            }

            const promotions = (((awaitedRes || {}).data || {}).promotion || []).map(function (promo) {
                return {
                    offerId: promo.offerId,
                    promotionClass: promo.promotionClass,
                    discount: promo.discount,
                    message: promo.message
                };
            });

            if (!isNullOrFieldsEmpty(variant)) {
                //data.variants.find(({sku}) => sku === skuIfNotFirstVariant)
                variant.totalPrice = priceObject;
                variant.totalPoints = pointsObject;
                variant.promotions = promotions;
                if (quantity === 1)  /* istanbul ignore next */ {
                    variant.price = priceObject;
                    variant.points = pointsObject;
                }
            } else if (!isNullOrEmpty(bundle)) {
                bundle.totalPrice = priceObject;
                bundle.totalPoints = pointsObject;
                bundle.promotions = promotions;
                if (quantity === 1) {
                    bundle.price = priceObject;
                    bundle.points = pointsObject;
                }
            }

            return {
                points: pointsObject,
                price: priceObject,
                promotions: promotions
            };
        } catch (ex)  /* istanbul ignore next */ {
            console.log(ex);
            return {};
        }
    };

    const getSalesEventPricing = async (sku, market, quantity) => {
        const promotions = [];
        const activeSalesEvents = await getActiveSalesEvents(market);
        if (!sku || !sku.pricingJson) {
            return;
        }
        const pricing = fromJsonString(sku.pricingJson, {});
        const pricingRetail = pricing.retail || {};
        const pricingWholesale = pricing.wholesale || {};
        let priceObject = sku.price ? { ...sku.price } : {};
        let pointsObject = sku.points
            ? { wholesale: { ...sku.points.wholesale }, subscription: { ...sku.points.subscription } }
            : {};
        for (const activeEvent of activeSalesEvents) {
            let retailPrice = getProp(pricing, `retail.${activeEvent.eventName}.price`, null);
            priceObject.retailSales = isNullOrEmpty(retailPrice) ? priceObject.retailSales : retailPrice;
            const retail = pricingRetail.webOrder || pricingRetail.order;
            priceObject.retail = isNullOrEmpty(retail) ? priceObject.retail : retail.price;
            priceObject.retailSubscription =
                isNullOrEmpty(pricingRetail.webAdr) || !pricingRetail.webAdr.price
                    ? null
                    : pricingRetail.webAdr.price;

            let wholesalePrice = getProp(pricing, `wholesale.${activeEvent.eventName}.price`, null);
            priceObject.wholesaleSales = isNullOrEmpty(wholesalePrice) ? priceObject.wholesaleSales : wholesalePrice;
            const wholesale = pricingWholesale.webOrder || pricingWholesale.order;
            priceObject.wholesale = isNullOrEmpty(wholesale) ? priceObject.wholesale : wholesale.price;

            const wholesaleSubscriptionPrice = pricingWholesale.ADR5 || pricingWholesale.WADW || pricingWholesale.webAdr;

            priceObject.wholesaleSubscription =
                isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.price
                    ? null
                    : wholesaleSubscriptionPrice.price;

            let wholesaleCv = getProp(pricing, `wholesale.${activeEvent.eventName}.cv`, null);
            wholesaleCv = wholesaleCv || (wholesale && wholesale.cv)
            pointsObject.wholesale.cv = isNullOrEmpty(wholesaleCv) ? pointsObject.wholesale.cv : wholesaleCv;
            if (!pointsObject.wholesale.cv) {
                pointsObject.wholesale.cv = wholesale.cv ? wholesale.cv : null;
            }
            pointsObject.subscription.cv =
                isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.cv
                    ? null
                    : wholesaleSubscriptionPrice.cv;

            let wholesalePv = getProp(pricing, `wholesale.${activeEvent.eventName}.pv`, null);
            wholesalePv = wholesalePv || (wholesale && wholesale.pv)
            pointsObject.wholesale.pv = isNullOrEmpty(wholesalePv) ? pointsObject.wholesale.pv : wholesalePv;
            if (!pointsObject.wholesale.pv) {
                pointsObject.wholesale.pv = wholesale.pv ? wholesale.pv : null;
            }
            pointsObject.subscription.pv =
                isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.pv
                    ? null
                    : wholesaleSubscriptionPrice.pv;

            let wholesaleSb = getProp(pricing, `wholesale.${activeEvent.eventName}.SB`, null);
            wholesaleSb = wholesaleSb || (wholesale && wholesale.SB)
            pointsObject.wholesale.sb = isNullOrEmpty(wholesaleSb) ? pointsObject.wholesale.sb : wholesaleSb;
            if (!pointsObject.wholesale.sb) {
                pointsObject.wholesale.sb = wholesale.sb ? wholesale.sb : null;
            }
            pointsObject.subscription.sb =
                isNullOrEmpty(wholesaleSubscriptionPrice) || !wholesaleSubscriptionPrice.SB
                    ? null
                    : wholesaleSubscriptionPrice.SB;

            if (priceObject.retailSales && priceObject.wholesaleSales) {
                pointsObject.wholesale.grp = Number(Number((priceObject.retailSales - priceObject.wholesaleSales) || 0).toFixed(2))
            } else {
                pointsObject.wholesale.grp = Number(Number((priceObject.retail || NaN) - (priceObject.wholesale || NaN)  || 0).toFixed(2))
            }
            pointsObject.subscription.grp = Number(Number((priceObject.retailSubscription || NaN) - (priceObject.wholesaleSubscription || NaN) || 0).toFixed(2))

            promotions.push({ offerId: activeEvent.eventName, promotionClass: "salesEvent", startTimestamp: activeEvent.startTimestamp, endTimestamp: activeEvent.endTimestamp, eventEnabled: activeEvent.eventEnabled, markets: activeEvent.markets });
        }

        sku.price = priceObject;
        sku.points = pointsObject;
        sku.promotions = promotions;

        sku.totalPrice = {
            retail: sku.price.retail ? Number(sku.price.retail * quantity).toFixed(2) : null,
            retailSales: sku.price.retailSales ? Number(sku.price.retailSales * quantity).toFixed(2) : null,
            retailSubscription: sku.price.retailSubscription ? Number(sku.price.retailSubscription * quantity).toFixed(2) : null,
            wholesale: sku.price.wholesale ? Number(sku.price.wholesale * quantity).toFixed(2) : null,
            wholesaleSales: sku.price.wholesaleSales ? Number(sku.price.wholesaleSales * quantity).toFixed(2): null,
            wholesaleSubscription: sku.price.wholesaleSubscription ? Number(sku.price.wholesaleSubscription * quantity).toFixed(2) : null
        }
        if (sku.price.currencyCode) {
            sku.totalPrice.currencyCode = sku.price.currencyCode
        }
        sku.totalPoints = {
            subscription: {
                cv: sku.points.subscription.cv ? Number(sku.points.subscription.cv * quantity).toFixed(2) : null,
                pv: sku.points.subscription.pv ?  Number(sku.points.subscription.pv * quantity).toFixed(2) : null,
                sb: sku.points.subscription.sb ?  Number(sku.points.subscription.sb * quantity).toFixed(2) : null,
                grp: sku.points.subscription.grp ?  Number(sku.points.subscription.grp * quantity).toFixed(2) : null
            },
            wholesale: {
                cv: sku.points.wholesale.cv ?  Number(sku.points.wholesale.cv * quantity).toFixed(2) : null,
                pv: sku.points.wholesale.pv ?  Number(sku.points.wholesale.pv * quantity).toFixed(2) : null,
                sb: sku.points.wholesale.sb ?  Number(sku.points.wholesale.sb * quantity).toFixed(2) : null,
                grp: sku.points.wholesale.grp ?  Number(sku.points.wholesale.grp * quantity).toFixed(2) : null
            }
        }
        if (quantity === 1) {
            return { price: sku.price, points: sku.points, promotions: sku.promotions };
        } else {
            return { price: sku.totalPrice, points: sku.totalPoints, promotions: sku.promotions };
        }
    }

    const getCsPricing = async (variant, bundle, selectedSkus, quantity, okta, market) => {
        quantity = quantity || 1
        market = market ? market.toUpperCase() : null
        if (isNullOrEmpty(variant) && isNullOrEmpty(bundle)) {
            return {};
        }
        if (!isNullOrFieldsEmpty(variant)) {
            let sku = variant;
            return await getSalesEventPricing (sku, market, quantity)
        }
        if (!isNullOrFieldsEmpty(bundle)) {
            if (bundle.type === 'kit') {
                let sku = bundle;
                return await getSalesEventPricing (sku, market, quantity) 
            } 

            selectedSkus = selectedSkus || [];
            const variantsGettingPriced = [];
            for (const bundleItem of data.bundle.kitProducts) {
                const variants = bundleItem.product.variants || [];
                for (const variant of variants) {
                    if (selectedSkus.some((r) => variant.sku === r)) {
                        variantsGettingPriced.push({
                            ...(await getCsPricing(variant, null, null, 1, okta, market)),
                            sku: variant.sku,
                            bundleQuantity: quantity,
                            variantQuantity: bundleItem.quantity
                        });
                    }
                }
            }

            let retail = 0;
            let retailSales = 0;
            let retailSubscription = 0;
            let wholesale = 0;
            let wholesaleSales = 0;
            let wholesaleSubscription = 0;
            let subscribeCV = 0;
            let subscribePV = 0;
            let subscribeSB = 0;
            let wholesaleCV = 0;
            let wholesalePV = 0;
            let wholesaleSB = 0;
            let offerId = "";
            let promotionClass = "";
            let discount = "";
            let message = "";

            variantsGettingPriced.forEach((v) => {
                retail = retail + (v.price || {}).retail * v.variantQuantity;
                retailSales = retailSales + (v.price || {}).retailSales * v.variantQuantity;
                retailSubscription = retailSubscription + (v.price || {}).retailSubscription * v.variantQuantity;
                wholesale = wholesale + (v.price || {}).wholesale * v.variantQuantity;
                wholesaleSales = wholesaleSales + (v.price || {}).wholesaleSales * v.variantQuantity;
                wholesaleSubscription =
                    wholesaleSubscription + (v.price || {}).wholesaleSubscription * v.variantQuantity;
                subscribeCV = subscribeCV + ((v.points || {}).subscription || {}).cv * v.variantQuantity;
                subscribePV = subscribePV + ((v.points || {}).subscription || {}).pv * v.variantQuantity;
                subscribeSB = subscribeSB + ((v.points || {}).subscription || {}).sb * v.variantQuantity;
                wholesaleCV = wholesaleCV + ((v.points || {}).wholesale || {}).cv * v.variantQuantity;
                wholesalePV = wholesalePV + ((v.points || {}).wholesale || {}).pv * v.variantQuantity;
                wholesaleSB = wholesaleSB + ((v.points || {}).wholesale || {}).sb * v.variantQuantity;
                offerId = ((v.promotions || [])[0] || {}).offerId;
                promotionClass = ((v.promotions || [])[0] || {}).promotionClass;
                discount = ((v.promotions || [])[0] || {}).discount;
                message = ((v.promotions || [])[0] || {}).message;
            });

            retail = retail * quantity;
            retailSales = retailSales * quantity;
            retailSubscription = retailSubscription * quantity;
            wholesale = wholesale * quantity;
            wholesaleSales = wholesaleSales * quantity;
            wholesaleSubscription = wholesaleSubscription * quantity;
            const retailDiscount = retail * ((bundle.retailDiscount || 0) / 100);
            const wholesaleDiscount = wholesale * ((bundle.wholesaleDiscount || 0) / 100);

            const priceObjectWithoutDiscount = {
                retail,
                retailSales,
                retailSubscription,
                wholesale,
                wholesaleSales,
                wholesaleSubscription
            };

            const priceObject = {
                retail: retail - retailDiscount,
                retailSales,
                retailSubscription: retailSubscription - retailDiscount,
                wholesale: wholesale - wholesaleDiscount,
                wholesaleSales,
                wholesaleSubscription: wholesaleSubscription - wholesaleDiscount
            };

            const pointsObject = {
                subscription: {
                    cv: subscribeCV * quantity - (bundle.cvDiscount || 0),
                    pv: subscribePV * quantity - (bundle.pvDiscount || 0),
                    sb: subscribeSB * quantity - (bundle.sbDiscount || 0)
                },
                wholesale: {
                    cv: wholesaleCV * quantity - (bundle.cvDiscount || 0),
                    pv: wholesalePV * quantity - (bundle.pvDiscount || 0),
                    sb: wholesaleSB * quantity - (bundle.sbDiscount || 0)
                }
            };

            const promotions = {
                offerId,
                promotionClass,
                discount,
                message
            };

            return {
                points: pointsObject,
                price: priceObject,
                promotions: promotions,
                priceWithoutDiscount: priceObjectWithoutDiscount
            };
        }
    };

    const getPriceFromGraph = async (id, quantity, okta) => {
        const graphData =
            (await getProductById(
                id,
                data.productDataSource.market || "US",
                data.productDataSource.language || null,
                null,
                quantity,
                okta
            )) || {};
        let matchingVariant = {};
        productSource = graphData.productDataSource || {};
        productSource.market = productSource.market || "US";
        productSource.language = productSource.language || "en";
        for (const variant of graphData.variants || [])  /* istanbul ignore next */  {
            if (variant.sku === id) {
                variant.matchingVariant = true;
                matchingVariant = variant;
            }
        }
        data.productDataSource = productSource;
        if (quantity === 1) {
            return {
                points: matchingVariant.points,
                price: matchingVariant.price,
                promotions: matchingVariant.promotions
            };
        }

        return {
            points: matchingVariant.totalPoints,
            price: matchingVariant.totalPrice,
            promotions: matchingVariant.promotions
        };
    }

    const getPricing = async (quantity, okta, skuIfNotFirstVariant, selectedSkus) => {
        if (!isNullOrEmpty(data.bundle)) {
            if (((data || {}).productDataSource || {}).source === "equinox") {
                const bundlePricing = await getEqPricing(null, data.bundle, selectedSkus, quantity, okta);
                return bundlePricing;
            }
            const bundlePricing = await getCsPricing(null, data.bundle, selectedSkus, quantity, okta, data.productDataSource.market);
            return bundlePricing;
        } else {
            if (!isNullOrFieldsEmpty(data.variants)) {
                let variantPricing = {};
                let returnPricing = {};
                let variantCount = 0;
                for (const variant of data.variants) {
                    if (variant.matchingVariant) {
                        skuIfNotFirstVariant = variant.sku;
                    }
                    if (((data || {}).productDataSource || {}).source === "equinox") {
                        if (quantity === 1) {
                            variantPricing = await getPriceFromGraph(variant.sku, quantity, okta);
                        } else  /* istanbul ignore next */ {
                            variantPricing = await getEqPricing(variant, null, variant.sku, quantity, okta)
                        }
                    } else {
                        variantPricing = await getCsPricing(variant, null, variant.sku, quantity, okta, data.productDataSource.market);
                    }

                    if (variantCount++ === 0) {
                        returnPricing = { ...variantPricing }
                    }
                    if (skuIfNotFirstVariant && variant.sku === skuIfNotFirstVariant) {
                        returnPricing = { ...variantPricing }
                    }
                }
                return returnPricing
            }
            return {}
        }
    };

    const updateBundleAttributes = (selectedSkus) => {
        if (!isNullOrEmpty(data.bundle)) {
            const dateFormat = "YYYY-MM-DD"
            selectedSkus = selectedSkus || [];
            let latestBODate = null;
            let isBackordered = false;
            let availableQuantity = data.bundle.atpQuantity > -1 ? data.bundle.atpQuantity : data.bundle.availableQuantity || 0;
            let maxQuantity = data.bundle.maxQuantity || 0;
            let backorderQuantity = data.bundle.backorderQuantity || 0;
            let dangerousGoods = false;
            let statusIsSellable = true;
            let availableQuantities = [];
            let maxQuantities = [];
            let dangerousGoodsArr = [];
            let statusArr = [];
            for (const bundleItem of ((data.bundle || {}).kitProducts || [])) {
                const variants = ((bundleItem || {}).product || {}).variants || [];
                const bundleItemQuantity = (bundleItem || {}).quantity || 1;
                let variant = ((variants || [])[0] || {});
                if (variants.length > 0 && selectedSkus.some((r) => variants.map((s) => s.sku).includes(r))) {
                    variant = (variants.filter((v) => selectedSkus.includes(v.sku)) || [])[0] || variant;
                } else if (!(bundleItem || {}).isMandatory) {
                    variant = null;
                }
                if (variant) {
                    if ((variant.status || {}).inventory === 'backordered') {
                        isBackordered = true;
                        const variantBODate = variant.backorderedAvailableDate;
                        if (latestBODate && variantBODate) {
                            latestBODate =
                                moment(latestBODate).format(dateFormat) > moment(variantBODate).format(dateFormat)
                                    ? moment(latestBODate).format(dateFormat)
                                    : moment(variantBODate).format(dateFormat);
                        } else if (latestBODate && !variantBODate) {
                            latestBODate = moment(latestBODate).format(dateFormat);
                        } else if (variantBODate) {
                            latestBODate = moment(variantBODate).format(dateFormat);
                        }
                    }
                    availableQuantities.push(Math.floor((variant.atpQuantity || 0)/bundleItemQuantity));
                    maxQuantities.push(((variant.backorderQuantity || 0) + (variant.atpQuantity || 0))/bundleItemQuantity);
                    dangerousGoodsArr.push(variant.dangerousGoods);
                    statusArr.push((variant.status || {}).status);
                }
            }
            availableQuantity = Math.min(...availableQuantities);
            maxQuantity = Math.floor(Math.min(...maxQuantities));
            const checkIfNegative = (maxQuantity - availableQuantity) < 0;
            backorderQuantity = checkIfNegative ? 0 : maxQuantity - availableQuantity;
            dangerousGoods = dangerousGoodsArr.includes(true);
            statusArr.forEach((status) => {
                ["NOT_RELEASED_FOR_SALE", "STOP_STATUS", "DISCONTINUED", "inactive", "INACTIVE"].forEach(
                    (badStatus) => {
                        if (badStatus === status)  /* istanbul ignore next */ {
                            statusIsSellable = false;
                        }
                    }
                );
            });
            const status = {
                status: statusIsSellable ? "sellable" : "inactive",
                isBackordered,
                backorderedAvailableDate: latestBODate,
                inventory: isBackordered && maxQuantity > 0 ? 'backordered' : availableQuantity > 0 ? 'inStock' : 'outOfStock'
            };
            data.bundle.status = status;
            data.bundle.availableQuantity = availableQuantity;
            data.bundle.atpQuantity = availableQuantity;
            data.bundle.maxQuantity = maxQuantity;
            data.bundle.backorderQuantity = backorderQuantity;
            data.bundle.dangerousGoods = dangerousGoods;
            return { status, availableQuantity, atpQuantity: availableQuantity, maxQuantity, backorderQuantity, dangerousGoods }
        }
    };

    return { data, getPricing, updateBundleAttributes, getEqPricing, getCsPricing }
};

const getPricingForId = async (id, market, language, quantity, environment, oktaToken, includedBundleSkus, useContentSource) => {
    if (!id || !market || !language) {
        return {};
    }
    const fromId = await getProduct({ fromId: id, market, language, env: environment || "test", useContentSource });
    const variantSku = id.match(/^\d{8}$/) ? id : null;
    const pricing = await fromId.getPricing(quantity || 1, oktaToken, variantSku, includedBundleSkus || [], useContentSource);
    return pricing;
};

const getPricingForSlug = async (slug, market, language, quantity, environment, oktaToken, includedBundleSkus, useContentSource) => {
    if (!slug || !market || !language) {
        return {};
    }
    const fromId = await getProduct({ fromSlug: slug, market, language, env: environment || "test", useContentSource });
    const pricing = await fromId.getPricing(quantity || 1, oktaToken, null, includedBundleSkus || []);
    return pricing;
};

module.exports = {
    getPDPStrings,
    getProduct,
    getPricingForId,
    getPricingForSlug,
    getPublishedProducts,
    setActiveSalesEvents,
    getActiveSalesEvents,
    getProductsById,
    getCPStrings
};